import * as React from 'react';
import {useEffect, useRef} from 'react';

interface Props {

}

const FeedWells : React.FC<Props> = props => {
    const didMountRef = useRef(false);

    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    return <>
        <div style={{color: "#FF8000", fontSize: "3rem"}}>Feed
            <label style={{color: "#39FF14", fontSize: "3rem"}}>Wells</label>
        </div>
    </>
};

export default FeedWells
